import { createUseStyles } from "react-jss";

export const UserProfileUserContainerStyle = createUseStyles((_theme: any) => ({
    container: {
        padding: "32px 0",
    },
}));
